import _, { get as _get } from 'lodash-es';

/* 1. constants read from the window config object to be added here */
export const defaultCurrency = _get(
  window,
  'compatioConfig.compatibleProducts.currency'
);
export const defaultCurrencySub = _get(
  window,
  'compatioConfig.compatibleProducts.currencySub'
);
export const productsPerPage = _get(
  window,
  'compatioConfig.compatibleProducts.productsPerPage'
)
  ? _get(window, 'compatioConfig.compatibleProducts.productsPerPage')
  : 20;

export const backingProducts =
  typeof _get(window, 'compatioConfig.shopify') === 'object'
    ? _get(window, 'compatioConfig.compatibleProducts.backingData')
    : [
        { name: '20 lb Dacron', variantId: '34368719814788' },
        { name: '30 lb Dacron', variantId: '34368719847556' },
      ];

export const shopifyObj = _get(window, 'compatioConfig.shopify');
// export const targetGraph = _get(window, 'compatioConfig.shopify.targetGraph');
export const targetGraph = _get(window, 'compatioConfig.shopify.targetGraph')
  ? _get(window, 'compatioConfig.shopify.targetGraph')
  : _get(window, 'compatioConfig.magento.targetGraph');
export const optionData = _get(
  window,
  'compatioConfig.compatibleProducts.optionsData'
)
  ? _get(window, 'compatioConfig.compatibleProducts.optionsData')
  : [];
export const eCommercePlatform =
  typeof _get(window, 'compatioConfig.shopify') === 'object'
    ? 'shopify'
    : 'magento';
export const maximumProducts = _get(
  window,
  'compatioConfig.shopify.maximumProducts'
);
export const maximumCategories = _get(
  window,
  'compatioConfig.shopify.maximumCategories'
);
export const defaultSorting = _get(
  window,
  'compatioConfig.compatibleProducts.sorting'
);

/* 2. constants defined as default props to be added here*/
export const sorting = {
  compatioscore_descending: {
    label: 'Recommended',
    sortDirection: 'ascending',
    productKey: 'compatioScore',
  },
  best_selling: {
    label: 'Best Selling',
    sortDirection: 'ascending',
    productKey: 'bestSelling',
  },
  price_ascending: {
    label: 'Price (low to high)',
    sortDirection: 'ascending',
    productKey: 'price',
  },
  price_descending: {
    label: 'Price (high to low)',
    sortDirection: 'descending',
    productKey: 'price',
  },
  alphabetical_ascending: {
    label: 'Alphabetical (A > Z)',
    sortDirection: 'ascending',
    productKey: 'productName',
  },
  alphabetical_descending: {
    label: 'Alphabetical (Z > A)',
    sortDirection: 'descending',
    productKey: 'productName',
  },
  date_ascending: {
    label: 'Date (new to old)',
    sortDirection: 'descending',
    productKey: 'createdAt',
  },
  date_descending: {
    label: 'Date (old to new)',
    sortDirection: 'ascending',
    productKey: 'createdAt',
  },
};
export const categoryMap = [
  {
    compatioCategory: 'Fly Lines',
    shopifyValues: [
      'Lines',
      'Fly Lines - Freshwater Fly Lines',
      'Fly Lines - Saltwater Fly Lines',
      'Fly Lines - Two Handed Tips & Running Lines',
    ],
  },
  {
    compatioCategory: 'Chainring',
    shopifyValues: ['CHAINRING'],
  },
  {
    compatioCategory: 'CRANKSET',
    shopifyValues: ['CRANKSET'],
  },
  {
    compatioCategory: 'CASSETTE',
    shopifyValues: ['CASSETTE'],
  },
  {
    compatioCategory: 'CHAIN',
    shopifyValues: ['CHAIN'],
  },
  {
    compatioCategory: 'FRONT-DERAILLEUR',
    shopifyValues: ['FRONT-DERAILLEUR'],
  },
  {
    compatioCategory: 'REAR-DERAILLEUR',
    shopifyValues: ['REAR-DERAILLEUR'],
  },
  {
    compatioCategory: 'BRAKE SHIFTLEVER',
    shopifyValues: ['BRAKE SHIFTLEVER'],
  },
  {
    compatioCategory: 'GRIP-SHIFTER',
    shopifyValues: ['GRIP-SHIFTER'],
  },
  {
    compatioCategory: 'SHIFTLEVER',
    shopifyValues: ['SHIFTLEVER'],
  },
  {
    compatioCategory: 'Leader',
    shopifyValues: [
      'Leaders & Tippet - Freshwater Leaders',
      'Leaders & Tippet - Saltwater Leaders',
    ],
  },
  {
    compatioCategory: 'Tippet',
    shopifyValues: [
      'Leaders & Tippet - Freshwater Tippet',
      'Leaders & Tippet - Saltwater Tippet',
      'Leaders & Tippet - Wire & Shock Tippet',
    ],
  },
  {
    compatioCategory: 'Reels',
    shopifyValues: ['Reels'],
  },
  {
    compatioCategory: 'Fly Rods',
    shopifyValues: ['Rods'],
  },
  {
    compatioCategory: 'DRUM-KIT',
    shopifyValues: ['drum kit', 'drm kit', 'drum kits'],
  },
  {
    compatioCategory: 'DRUM-HEAD',
    shopifyValues: ['Drum Heads'],
  },
];

/* 3. API endpoint URLs to be added here*/
export const collectionFilterSpxApiUrl = [
  {
    Region: 'Live',
    label: 'prod-live',
    Url: 'https://spx.compat.io/v3/abs',
  },
  {
    Region: 'Master',
    label: 'prod-master',
    Url: 'https://spx.compat.io/v3/abs',
  },
  {
    Region: 'MasterV2Dev',
    label: 'prod-master',
    Url: 'https://spx.compat.io/v3/abs',
  },
  ,
  {
    Region: 'LiveV2-api',
    label: 'prod-live',
    Url: 'https://spx.compat.io/v3/abs',
  },
];
export const targetGraphApiEndpoint = [
  {
    Region: 'Live',
    label: 'prod-live',
    Url: 'https://spx.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'LiveV2',
    label: 'prod-master',
    Url: 'https://spx-v2.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'LiveV2-api',
    label: 'prod-master',
    Url: 'https://smartbuilder.compat.io',
  },
  {
    Region: 'Master',
    label: 'prod-master',
    Url: 'https://spx-qa.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'MasterV2Dev',
    label: 'prod-master',
    Url: 'https://spx-qa.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'Stage',
    label: 'stage',
    Url: 'https://spx-qa.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'MasterV2',
    label: 'prod-master',
    Url: 'https://spx-v2.compat.io/v0/searchResultsLambdaMAP',
  },
  {
    Region: 'Dev',
    label: 'prod-master',
    Url: 'https://8xj2musshl.execute-api.us-east-2.amazonaws.com/compatioxrs',
  },
  {
    Region: 'QA',
    label: 'prod-master',
    Url: 'https://m6a9hz8t5d.execute-api.us-east-2.amazonaws.com/qa',
  },
  { Region: 'Preview', label: 'prod-master', Url: '' },
];
export const successTickImageUrl =
  'https://cdn2.iconfinder.com/data/icons/modifiers-essential-colored/48/JD-24-512.png';
export const bundlerIconImageUrl =
  'https://cdn3.iconfinder.com/data/icons/navigation-and-settings/24/Material_icons-01-07-512.png';

/*4. Other general purpose constants which are used at many places to be added here*/
export const graphLabel = targetGraphApiEndpoint.find(
  o => o.Region === targetGraph
).label;

//collectionFilterSpxApiUrl
export const CollectiongraphLabel = collectionFilterSpxApiUrl.find(
  o => o.Region === targetGraph
).label;
